import { GetPipeSeriesStatus200 } from "@imi/api-client/index.js";
import { z } from "zod/v4";

export type CustomPipeSeries = z.infer<typeof customPipeSeriesSchema>;

// The ids in the engine are strings, but the API returns them as numbers
// so we convert them to strings here for consistency in the forms.
export function buildCustomPipeSeries(
  pipeSeries: GetPipeSeriesStatus200 | undefined,
): CustomPipeSeries[] {
  if (!pipeSeries) return [];
  return pipeSeries.map((series) => ({
    ...series,
    id: series.id.toString(),
    pipes: series.pipes.map((pipe) => ({
      ...pipe,
      id: pipe.id.toString(),
    })),
  }));
}

export const customPipeSeriesSchema = z.object({
  id: z.string(),
  name: z.string().min(1, "pipeSeries.add.fields.name.errors.required"),
  pipes: z.array(
    z.object({
      id: z.string(),
      internalDiameter: z.number(
        "pipeSeries.add.fields.pipes.internalDiameter.errors.required",
      ),
      maxPressure: z.number(
        "pipeSeries.add.fields.pipes.maxPressure.errors.required",
      ),
      maxTemperature: z.number(
        "pipeSeries.add.fields.pipes.maxTemperature.errors.required",
      ),
      name: z
        .string()
        .min(1, "pipeSeries.add.fields.pipes.name.errors.required"),
      roughness: z.number(
        "pipeSeries.add.fields.pipes.roughness.errors.required",
      ),
      valveSize: z.string(
        "pipeSeries.add.fields.pipes.valveSize.errors.required",
      ),
    }),
  ),
});
